<template>
  <v-col :cols="isLabelVisible ? 8 : 12" class="pa-0">
    <v-row no-gutters>
      <v-col v-if="isLabelVisible" cols="4" class="pa-0">
        <v-subheader style="height: auto; min-height: 48px">
          <span>
            {{ $i18n.t('offer.attributes.localization.addValuationClass') }}
          </span>
        </v-subheader>
      </v-col>
      <v-col :cols="isLabelVisible ? 8 : 12" class="pa-0">
        <v-row dense no-gutters>
          <v-col :cols="isLabelVisible ? 9 : 10">
            <v-select :readonly="!canEdit" v-model="selectedClass" :items="filteredClasses" outlined />
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="pa-2">
            <v-btn
              fab
              :dark="selectedClass ? true : false"
              :title="$i18n.t('offer.attributes.localization.addValuationClass')"
              small
              color="primary"
              class="mr-1"
              @click="addClass"
              :disabled="!selectedClass"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters v-for="(val, key) in value" :key="key">
      <v-col cols="4" class="pa-0">
        <v-subheader style="height: auto; min-height: 48px">
          <span>{{ key }}</span>
        </v-subheader>
      </v-col>
      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model.number="value[key]"
          type="number"
          :step="0.00001"
          label="ha"
          @keydown="isNumber"
          @change="validateValue($event, key)"
          :readonly="!canEdit"
          outlined
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="pa-2">
        <v-btn
          dark
          fab
          :title="$i18n.t('offer.attributes.localization.deleteUsableArea')"
          small
          color="danger"
          class="mr-1"
          @click="deleteClass(key)"
        >
          <v-icon dark>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'SoilClass',
  props: {
    canEdit: {
      type: Boolean,
      required: true
    },
    value: {
      required: true
    },
    isLabelVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  data: () => ({
    classes: ['I', 'II', 'III', 'IIIa', 'IIIb', 'IV', 'IVa', 'IVb', 'V', 'VI', 'VIz'],
    selectedClass: undefined
  }),
  computed: {
    filteredClasses() {
      return this.classes.filter(
        cl => !Object.keys(this.value || {}).includes(cl) // {} to fix na null na starcie
      );
    }
  },
  methods: {
    addClass() {
      if (this.selectedClass) {
        this.$set(this.value, this.selectedClass, 0);
        this.selectedClass = undefined;
      }
    },
    deleteClass(key) {
      this.$delete(this.value, key);
    },
    validateValue(value, key) {
      if (!value) {
        this.$set(this.value, key, 0);
      }
    }
  },
  created() {
    // fix na null na starcie
    if (!this.value) {
      this.$emit('input', {});
    }
  }
};
</script>

<style lang="scss" scoped>
</style>